import React from 'react';
import { ArrowRight, Download, FileText } from 'lucide-react';
type NavLink = {
  label: string;
  href: string;
};
type Resource = {
  label: string;
  href: string;
};
const navLinks: NavLink[] = [{
  label: 'Il problema',
  href: '#problema'
}, {
  label: 'La soluzione',
  href: '#prodotto'
}, {
  label: 'Risultati',
  href: '#case-study'
}, {
  label: 'Pricing',
  href: '#pricing'
}, {
  label: 'FAQ',
  href: '#faq'
}, {
  label: 'Richiedi demo',
  href: '#cta'
}];
const companyLinks: NavLink[] = [{
  label: 'Manifesto',
  href: '#'
}, {
  label: 'Team',
  href: '#'
}, {
  label: 'News',
  href: '#'
}, {
  label: 'Contatti',
  href: 'mailto:info@aisac.io'
}];
const resources: Resource[] = [{
  label: 'Case Study (PDF)',
  href: '#'
}, {
  label: 'Company Profile (PDF)',
  href: '#'
}, {
  label: 'Brochure prodotto (PDF)',
  href: '#'
}, {
  label: 'White paper Delivery (PDF)',
  href: '#'
}];
const legalLinks: NavLink[] = [{
  label: 'Privacy policy',
  href: '#'
}, {
  label: 'Cookie policy',
  href: '#'
}, {
  label: 'Termini e condizioni',
  href: '#'
}, {
  label: 'GDPR',
  href: '#'
}];
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="relative py-12 pb-6 border-t border-default overflow-hidden" data-id="element-129">
      {/* Subtle radial accent behind brand column */}
      <div aria-hidden="true" className="absolute -top-24 -left-32 w-[480px] h-[480px] bg-[radial-gradient(circle,var(--accent-100),transparent_65%)] opacity-40 pointer-events-none z-0" data-id="element-130" />

      <div className="wrap relative z-10" data-id="element-131">
        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1.2fr)_minmax(0,2fr)] gap-10 lg:gap-16 mb-10" data-id="element-132">
          {/* Brand block */}
          <div data-id="element-133">
            <div className="mb-4 inline-flex items-center gap-2" data-id="element-134">
              <img src="https://cdn.magicpatterns.com/uploads/shBw6JChJTUctMasMwCyEU/4_6021369468377112115.svg" alt="Aisac" className="h-8 w-auto" style={{
              filter: 'brightness(0) invert(1)'
            }} data-id="element-135" />
            </div>
            <p className="text-body-sm color-ink-secondary max-w-[320px] mb-5" data-id="element-136">
              Aisac è la piattaforma AI che migliora l'esperienza di delivery,
              ottimizza i costi di spedizione e aumenta il valore di ogni
              ordine.
            </p>
            <a href="#cta" className="inline-flex items-center gap-2 text-body-sm color-accent no-underline transition-colors duration-200 hover:opacity-80" data-id="element-137">
              Richiedi una demo
              <ArrowRight className="w-4 h-4" aria-hidden="true" data-id="element-138" />
            </a>
          </div>

          {/* Menus row */}
          <div className="grid grid-cols-1 sm:grid-cols-[minmax(0,0.7fr)_minmax(0,1.3fr)_minmax(0,1fr)] gap-0" data-id="element-139">
            {/* Menu */}
            <div data-id="element-140">
              <h4 className="text-mono-label color-ink-primary mb-4 font-normal uppercase tracking-wider" data-id="element-141">
                Menu
              </h4>
              <ul className="list-none" data-id="element-142">
                {navLinks.map(link => <li key={link.label} className="py-1 text-body-sm" data-id="element-143">
                    <a href={link.href} className="inline-block color-ink-secondary no-underline" data-id="element-144">
                      {link.label}
                    </a>
                  </li>)}
              </ul>
            </div>

            {/* Risorse */}
            <div data-id="element-145">
              <h4 className="text-mono-label color-ink-primary mb-4 font-normal uppercase tracking-wider" data-id="element-146">
                Risorse
              </h4>
              <ul className="list-none" data-id="element-147">
                {resources.map(res => <li key={res.label} className="py-1 text-body-sm" data-id="element-148">
                    <a href={res.href} download target="_blank" rel="noopener" className="inline-flex items-center gap-2 color-ink-secondary no-underline" data-id="element-149">
                      <FileText className="w-3.5 h-3.5 flex-shrink-0" aria-hidden="true" data-id="element-150" />
                      <span data-id="element-151">{res.label}</span>
                    </a>
                  </li>)}
              </ul>
            </div>

            {/* Legal */}
            <div data-id="element-152">
              <h4 className="text-mono-label color-ink-primary mb-4 font-normal uppercase tracking-wider" data-id="element-153">
                Legal
              </h4>
              <ul className="list-none" data-id="element-154">
                {legalLinks.map(link => <li key={link.label} className="py-1 text-body-sm" data-id="element-155">
                    <a href={link.href} className="inline-block color-ink-secondary no-underline" data-id="element-156">
                      {link.label}
                    </a>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="pt-5 border-t border-default flex justify-between text-mono-tiny color-ink-tertiary flex-wrap gap-3" data-id="element-157">
          <span data-id="element-158">
            © {year} AISAC SRLS <span className="dot-separator" data-id="element-159"></span> P.IVA
            12910860019
          </span>
          <span data-id="element-160">Via Vandalino 73, Torino 10142</span>
          <span data-id="element-161">
            info@aisac.io <span className="dot-separator" data-id="element-162"></span> +39 333
            5768658
          </span>
        </div>
      </div>
    </footer>;
}